/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KpiDto } from '../../models/kpi-dto';

export interface SendHealthWelfareKpi$Params {
  cropId: number;
}

export function sendHealthWelfareKpi(http: HttpClient, rootUrl: string, params: SendHealthWelfareKpi$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiDto>> {
  const rb = new RequestBuilder(rootUrl, sendHealthWelfareKpi.PATH, 'get');
  if (params) {
    rb.path('cropId', params.cropId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KpiDto>;
    })
  );
}

sendHealthWelfareKpi.PATH = '/api/kpi/crop/{cropId}/send';
